import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rd-cell',
  templateUrl: './rd-cell.component.html',
  styleUrls: ['./rd-cell.component.scss']
})
export class RDCellComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
